export default "__VITE_ASSET__D38DibyX__"